'use strict';

var index = require('../../../../../index-B_8xeRkv.js');

"use strict";
const pluginVersion = "12.4.2";
const defaultOptions = {
  colWidth: 0.9,
  perPage: 20,
  rowHeight: 0.9,
  showValue: index.VisibilityMode.Auto
};
const defaultFieldConfig = {
  fillOpacity: 70,
  lineWidth: 1
};

exports.defaultFieldConfig = defaultFieldConfig;
exports.defaultOptions = defaultOptions;
exports.pluginVersion = pluginVersion;
